import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Loader2 } from 'lucide-react';

const INPUT_CLS = "bg-white/5 border-white/15 text-white placeholder:text-white/25 focus:border-[#D4A017] focus:ring-0 focus-visible:ring-0 focus-visible:ring-offset-0";

function FormField({ label, children }) {
  return (
    <div>
      <Label className="text-white/65 text-sm mb-1.5 block">{label}</Label>
      {children}
    </div>
  );
}

export function ContactForm({ form, submitting, update, set, handleSubmit, text }) {
  return (
    <form onSubmit={handleSubmit} className="space-y-4" data-testid="contact-form">
      <FormField label={text.name}>
        <Input id="contact-name" data-testid="contact-name-input" value={form.name} onChange={update('name')} required className={INPUT_CLS} />
      </FormField>

      <FormField label={text.email}>
        <Input id="contact-email" type="email" data-testid="contact-email-input" value={form.email} onChange={update('email')} required className={INPUT_CLS} />
      </FormField>

      <FormField label={text.interest}>
        <Select value={form.interest} onValueChange={set('interest')}>
          <SelectTrigger data-testid="contact-interest-select" className={`${INPUT_CLS} [&>span]:text-white/60`}>
            <SelectValue placeholder="Select..." />
          </SelectTrigger>
          <SelectContent className="bg-[#1a1a1a] border-white/15 text-white">
            {text.interestOptions.map((opt) => (
              <SelectItem key={opt} value={opt} className="text-white/80 focus:bg-white/10 focus:text-white cursor-pointer">{opt}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FormField>

      <FormField label={text.message}>
        <Textarea id="contact-message" data-testid="contact-message-input" value={form.message} onChange={update('message')} required rows={4}
          className={`${INPUT_CLS} resize-none`} />
      </FormField>

      <button type="submit" data-testid="contact-submit-btn" disabled={submitting}
        className="w-full bg-[#D4A017] hover:bg-[#F5B814] disabled:opacity-60 text-black font-semibold py-3.5 text-sm tracking-wide transition-colors duration-200 flex items-center justify-center gap-2 mt-2"
        style={{ fontFamily: "'Outfit', sans-serif" }}>
        {submitting && <Loader2 size={14} className="animate-spin" />}
        {text.send}
      </button>
    </form>
  );
}
